import React, { useContext, useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthContext } from '../../Layout/AuthContext';
import Alert from '../../Components/Alert/Alert';
import Login from '../Login/Login';
import BillingAdmin from '../../Components/BillingAdmin/BillingAdmin';
import SignupCodesPage from '../System/SignupCodesPage';
import OrganizationList from '../../Components/OrganizationList/OrganizationList';
import EmailNotificationsPage from '../../Components/System/EmailNotificationsPage';
import TrinityShell from './TrinityShell';
import TrinityDashboard from './TrinityDashboard';
import TrinityAiModels from './TrinityAiModels';
import TrinitySystemSettings from './TrinitySystemSettings';
import TrinityKnowledge from './TrinityKnowledge';
import TrinityLegalPacks from './TrinityLegalPacks';
import TrinityJobs from './TrinityJobs';
import TrinityZavvyUsage from './TrinityZavvyUsage';
import TrinityZavvyChat from './TrinityZavvyChat';
import TrinityTrustCenterAccess from './TrinityTrustCenterAccess';

const TrinityApp = () => {
  const { isAuthenticated, logout } = useContext(AuthContext);

  useEffect(() => {
    document.title = 'Zavior - Admin Portal';
  }, []);

  if (!isAuthenticated) {
    return (
      <>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Alert />
      </>
    );
  }

  return (
    <>
      <TrinityShell onLogout={logout}>
        <Routes>
          <Route path="/dashboard" element={<TrinityDashboard />} />
          <Route path="/billing" element={<BillingAdmin />} />
          <Route path="/signup-codes" element={<SignupCodesPage />} />
          <Route path="/organizations" element={<OrganizationList />} />
          <Route path="/email-logs" element={<EmailNotificationsPage />} />
          <Route path="/ai-models" element={<TrinityAiModels />} />
          <Route path="/system-settings" element={<TrinitySystemSettings />} />
          <Route path="/knowledge" element={<TrinityKnowledge />} />
          <Route path="/legal-packs" element={<TrinityLegalPacks />} />
          <Route path="/jobs" element={<TrinityJobs />} />
          <Route path="/zavvy-usage" element={<TrinityZavvyUsage />} />
          <Route path="/zavvy-chat" element={<TrinityZavvyChat />} />
          <Route path="/trust-center-access" element={<TrinityTrustCenterAccess />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </TrinityShell>
      <Alert />
    </>
  );
};

export default TrinityApp;
